
document.addEventListener('DOMContentLoaded', function() {
    
    const stepsContainer = document.querySelector(".steps");
    const steps = stepsContainer.querySelectorAll(".step");
    const resetBtn = document.querySelector(".reset");
    const nextBtn = document.querySelector(".next-btn");
    const indicator = document.querySelector(".indicator");

    function getStepWidth(){
        return steps[0].offsetWidth + 8;
    }

    const TOTAL_STEPS = steps.length;
    const WIDTH = getStepWidth();
    const INDICATOR_WIDTH = indicator.offsetWidth
    let dist = 0;
    let currentIndex = 1;
    let currentIndicatorWidth = indicator.offsetWidth

    function increaseIndicatorWidth() {
        currentIndicatorWidth += INDICATOR_WIDTH;
        indicator.style.width = `${currentIndicatorWidth}px`
    }

    function resetIndicatorWidth() {
        indicator.style.width = `${INDICATOR_WIDTH}px`;
        currentIndicatorWidth = INDICATOR_WIDTH
    }

    function next(){
        if (currentIndex === TOTAL_STEPS - 1){
           
            nextBtn.classList.add("deactivate");
            resetBtn.classList.remove("deactivate-reset");
        }
        currentIndex += 1;
        dist += WIDTH;
        stepsContainer.style.transform = `translateX(-${dist}px)`
        increaseIndicatorWidth()
    }

    function reset() {
        nextBtn.classList.remove("deactivate");
        resetBtn.classList.add("deactivate-reset");
        currentIndex = 1;
        dist = 0;
        stepsContainer.style.transform = `translateX(0px)`;
        resetIndicatorWidth();
    }

    nextBtn.addEventListener('click', next);
    resetBtn.addEventListener('click', reset);
})